<template>
    <div class="modal-edit-tracker modal-edit-tracker--sub" v-show="showModal">
        <header class="modal-header">
            <h5 class="modal-title">
                
            </h5>
            <button type="button" aria-label="Close" class="close" @click="close"></button>
            <b-button v-if="step > 1 && (step > 2 || (!id && $store.state.user.enterprise_type != 'free'))" variant="primary" size="lg" @click="prevStep()" class="back-link"></b-button>
        </header>
        
        <!--<a class="link" @click="showModal = false">Close</a>-->

        <template v-if="step == 1">
            <div class="modal-sub modal-sub--dark">
                <h1 class="heading1 modal__title modal__title--primary pt-sm-5">Create New Tracker</h1>
                <ul class="create-tracker-list">
                    <li class="create-tracker-list__blank">
                        <a @click="setTrackerType('public')">
                            <h4 class="heading4">Public Challenge</h4>
                            <p>Startups can find your project and apply</p>
                        </a>
                    </li>
                    <li class="create-tracker-list__template">
                        <a @click="setTrackerType('internal')">
                            <h4 class="heading4">Internal Tracker</h4>
                            <p>Users within your company add and evaluate startups</p>
                        </a>
                    </li>
                </ul>
            </div>
        </template>
        
        <div class="modal-sub" v-if="step > 1">
            <div class="modal-sub__inner">

                <template v-if="selectTemplateStep">
            
                    <h1 class="heading1 modal__title">Choose a Template</h1>

                    <template v-if="templatesList.default.length">
                        <h4 class="heading4">SwitchPitch Templates</h4>

                        <ul class="list-template">
                            <li v-for="template in templatesList.default" :key="template.id">
                                <a @click="selectedTemplate = template; selectTemplateStep = false">
                                    <div>
                                        <h5 class="heading5 heading5--secondary">{{template.name}}</h5>
                                        <p>{{template.description}}</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </template>

                    <template v-if="templatesList.custom.length">
                        <h4 class="heading4">{{ $store.state.user.company_name }} Templates</h4>

                        <ul class="list-template">
                            <li class="list-template__list" v-for="template in templatesList.custom" :key="template.id">
                                <a @click="selectedTemplate = template; selectTemplateStep = false">
                                    <div>
                                        <h5 class="heading5 heading5--secondary">{{template.name}}</h5>
                                        <p>{{template.description}}</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </template>
                </template>
                <template v-else>

            <!--        First tracker page-->
                    <template v-if="step == 2">
                        <h1 class="heading1 modal__title mb-1">Add Tracker Details</h1>
                        <template v-if="selectedTemplate">
                            <ul class="list-template list-template--w-change">
                                <li class="list-template__list">
                                    <a @click="selectTemplateStep = true">
                                        <div>
                                            <h5 class="heading5 heading5--secondary">{{selectedTemplate.name}}</h5>
                                        </div>
                                        <span class="link link-normal">Change</span>
                                    </a>
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                            <ul class="list-template">
                                <li class="list-template__list">
                                    <a @click="selectTemplateStep = true" v-if="tracker.type != 'public' && canEditInfo && (templatesList.default.length || templatesList.custom.length)" class="link link-normal">Change tracker template</a>
                                </li>
                            </ul>
                        </template>

                        <b-row class="mb-4 mt-4">
                            <b-col cols="12" sm="7">
                                <div class="form form-modal">
                                    <h5 class="heading5 heading5--secondary">Tracker name</h5>
                                    <b-form-input class="form-control--mid" v-model="tracker.name" placeholder="Enter Tracker Name" :disabled="!canEditInfo"></b-form-input>
                                </div>
                            </b-col>
                            <b-col cols="12" sm="5">
                                <template v-if="!folderId">
                                    <h5 class="heading5 heading5--secondary">Folder</h5>
                                    <multiselect class="multiselect-mid"
                                        v-model="tracker.folder"
                                        :options="foldersList"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        :disabled="!canEditInfo"
                                    >
                                    </multiselect>
                                </template>
                            </b-col>
                        </b-row>

                        <h5 class="heading5 heading5--secondary">Permissions</h5>

                        <ul class="rows-list mb-3">
                            <li class="rows-list__form rows-list__form--transparent flex-sm-nowrap flex-wrap" v-if="canManageRoles">

                                <multiselect class="multiselect-mid mb-sm-0 mb-4"
                                     v-model="newPermission.holder"
                                     :options="actualPermissionHolders"
                                     placeholder="Select User"
                                     select-label=""
                                     deselect-label=""
                                     label="name"
                                     track-by="name"
                                >
                                    <template slot="option" slot-scope="props">
                                        <template v-if="props.option.type == 'group'">
                                            <div class="d-flex align-items-center">
                                                <div class="mr-2">
                                                    <Avatar v-if="props.option.avatar"
                                                        :username="props.option.name"
                                                        :src="props.option.avatar"
                                                        :size="30">
                                                    </Avatar>
                                                    <font-awesome-icon v-else :icon="['fa', 'users']" size="lg"  />
                                                </div>
                                                {{ props.option.name }}
                                            </div>

                                        </template>
                                        <template v-else>
                                            <div class="d-flex align-items-center">
                                                <div class="mr-2">
                                                    <Avatar
                                                        :username="props.option.name"
                                                        :src="props.option.avatar"
                                                        :size="30">
                                                    </Avatar>
                                                </div>
                                                {{ props.option.name }}
                                            </div>
                                        </template>
                                    </template>
                                </multiselect>
                                <span class="text-nowrap ml-3">Add as:</span>

                                <b-dropdown class="mx-3 dropdown--tertiary" variant="link" ref="roleDropdown" toggle-class="text-decoration-none" no-caret>

                                    <template #button-content>
                                        {{ newPermission.role.name }}
                                    </template>

                                    <b-dropdown-header>
                                        <ul class="modal-list">
                                            <li v-for="role in roles" :key="role.id" @click="newPermission.role = role; $refs.roleDropdown.hide()">
                                                <h5 class="heading5 heading5--secondary">{{ role.name }}</h5>
                                                <p>{{ role.description }}</p>
                                            </li>
                                        </ul>
                                    </b-dropdown-header>

                                </b-dropdown>

                                <b-button @click="addPermission" variant="primary" size="md" :disabled="!newPermission.holder">Add</b-button>
                            </li>

                            <li v-for="(permission, index) in tracker.permissions" :key="index">

                                <div class="image-block image-block--rounded">
                                    <Avatar
                                        :username="permission.name"
                                        :src="permission.avatar"
                                        :size="30">
                                    </Avatar>
                                </div>

                                <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                                <b-dropdown class="ml-auto dropdown--tertiary modal-list" variant="link" toggle-class="text-decoration-none" no-caret :disabled="!canManageRoles">
                                    <template #button-content>
                                        <h5 class="heading5 heading5--secondary text-capitalize">{{permission.role.name}}</h5>
                                    </template>

                                    <b-dropdown-item v-for="(role, index) in roles" :key="index" @click="permission.role = role">
                                        <h5 class="heading5 heading5--secondary">{{role.name}}</h5>
                                        <p>{{role.description}}</p>
                                    </b-dropdown-item>
                                </b-dropdown>

                                <a v-if="canManageRoles" @click="tracker.permissions.splice(index, 1)" class="link-remove link" href="#">Remove</a>
                            </li>
                        </ul>

                        <h5 class="heading5 heading5--secondary">Description</h5>

                        <div class="mb-4" >
                            <editor
                                v-model="tracker.description"
                                :disabled="!canEditInfo"
                                :apiKey="apiKeys.tinyMCE"
                                :init="defaults.editorOptions"
                            >
                            </editor>
                        </div>

                        <template v-if="advancedMode">
                            <div class="d-flex align-items-baseline mb-2">
                                <h5 class="heading5 heading5--secondary mr-4 mb-0">Tracker Details</h5>
                                <a v-if="canManageSubmitterFields" @click="$bvModal.show('addSubmitterFieldModal' + prefix)" class="link">+ Add Field</a>
                            </div>

                            <div v-for="(field, index) in tracker.submitterFields" :key="index" class="mb-4">
                                <h5 class="heading5 heading5--secondary">{{field.field.name}}</h5>
                                
                                <div class="form-control-wrapper">

                                    <custom-field
                                        :field="tracker.submitterFields[index].field"
                                        :value="tracker.submitterFields[index].value"
                                        :inline="false"
                                        :instantUpdate="false"
                                        :index="index"
                                        :disabled="!canFillSubmitterFields"
                                        v-on:customValueChanged="submitterValueChanged"
                                    >
                                    </custom-field>

                                    <a @click="tracker.submitterFields.splice(index, 1)" class="link-remove link-remove--blue link ml-2"></a>
                                </div>
                            </div>

                            <b-modal :id="'addSubmitterFieldModal' + prefix" title="Add Field">
                                <select v-model="newSubmitField" class="selectbox selectbox-mid">
                                    <option :value="null">
                                        Select field
                                    </option>

                                    <option v-for="(field, id) in actualSubmitterFields" :key="id" :value="field">
                                        {{field.name}}
                                    </option>
                                </select>

                                <template #modal-footer>
                                    <b-button variant="primary" @click="addSubmitterField" :disabled="!newSubmitField">Add</b-button>
                                </template>
                            </b-modal>

                        </template>

                        <template v-if="advancedMode">
                            <br>
                            <h5 class="heading5 heading5--secondary">Funnel</h5>

                            <p class="modal-text">Use to progress startups through different evaluation stages</p>
                            
                            <div class="input-checkbox">
                                <input id="enable-pipeline" type="checkbox" :disabled="!canEditInfo" v-model="tracker.enablePipeline">
                                <label for="enable-pipeline">Enable Funnel</label>
                            </div>
                            <br>

                            <template v-if="tracker.enablePipeline">
                                <h5 class="heading5 heading5--secondary">Default view</h5>

                                <div class="radio-block mb-4">
                                    <div class="radio-block__item radio-block__item--list">
                                        <input type="radio" value="list" :disabled="!canEditInfo" v-model="tracker.defaultView" id="dw1">
                                        <label for="dw1">List</label>
                                    </div>
                                    <div class="radio-block__item radio-block__item--pipeline">
                                        <input type="radio" value="pipeline" :disabled="!canEditInfo" v-model="tracker.defaultView" id="dw2">
                                        <label for="dw2">Funnel</label>
                                    </div>
                                </div>
                            </template>
                        </template>

                       <h5 class="heading5 heading5--secondary">Timeline</h5>
                        <div class="mb-4">
                            <date-picker v-model="timeline"
                                         format = "MM/DD/YYYY"
                                         :disabled="!canEditInfo"
                                         placeholder="Select Start / End Date"
                                         range>
                            </date-picker>
                        </div>

                        <h5 class="heading5 heading5--secondary">Categories</h5>
                        <div class="mb-4">
                            <multiselect class="multiselect-mid"
                                v-model="tracker.categories"
                                :options="categoriesList"
                                :multiple="true"
                                select-label=""
                                deselect-label=""
                                :disabled="!canEditInfo"
                                label="name"
                                track-by="name"
                            >
                            </multiselect>
                        </div>

                        <template v-if="advancedMode">
                            <h5 class="heading5 heading5--secondary">Reviews</h5>

                            <div class="d-flex mb-4">
                                <div class="input-radio mr-3">
                                    <input type="radio" value="1" :disabled="!canEditInfo" v-model="tracker.reviewsEnabled" id="tr1" name="tr">
                                    <label for="tr1">Enabled (recommended)</label>
                                </div>
                                <div class="input-radio">
                                    <input type="radio" value="0" :disabled="!canEditInfo" v-model="tracker.reviewsEnabled" id="tr2" name="tr">
                                    <label for="tr2">Disabled</label>
                                </div>
                            </div>

                            <template v-if="tracker.type == 'public'">
                                <h5 class="heading5 heading5--secondary">Settings</h5>
                                <div class="input-checkbox">
                                    <input id="only-referral" type="checkbox" :disabled="!canEditInfo" v-model="tracker.onlyReferral">
                                    <label for="only-referral">Only startups which have referral URL can apply</label>
                                </div>

                                <div class="input-checkbox mt-2">
                                    <input id="need-complete-profile" type="checkbox" :disabled="!canEditInfo" v-model="tracker.needCompleteProfile">
                                    <label for="need-complete-profile">Require startups to complete profiles to apply</label>
                                </div>
                            </template>

                            <div class="input-checkbox mt-2 mb-2" v-if="$store.state.user.company_id == constants.companyPfizer && tracker.type == 'internal'">
                                <h5 class="heading5 heading5--secondary">Settings</h5>
                                <input id="referral-link-access" type="checkbox" :disabled="!canEditInfo" v-model="tracker.InternalAccessById">
                                <label for="referral-link-access">Any user who has URL can see tracker</label>
                            </div>

                        </template>

                        <a @click="advancedMode = true" v-if="!advancedMode" class="link link-normal">Show advanced settings</a>
                        <a @click="advancedMode = false" v-if="advancedMode" class="link link-normal">Hide advanced settings</a>
                    </template>

                    <template v-if="step == 3">
                        <h1 class="heading1 modal__title">Funnel Stages</h1>

                        <p>Set up all the steps you want to track. You can edit these later.</p>

                        <multiselect class="multiselect-mid"
                            v-model="tracker.pipeline"
                            :options="pipelinesList"
                            select-label=""
                            deselect-label=""
                            label="name"
                            track-by="name"
                            :disabled="!canEditInfo"
                        >
                        </multiselect>

                        <ul v-if="tracker.pipeline" class="list-drag-n-drop list-drag-n-drop--full">
                            <li v-for="(step, index) in tracker.pipeline.steps" :key="index" class="list-drag-n-drop__item">
                                <span class="input-checkbox">
                                    {{step}}
                                </span>
                            </li>
                        </ul>

                        <a v-if="tracker.pipeline && canEditInfo" @click="$refs.EditPipeline.open(tracker.pipeline.id)">Manage Stages</a>
                    </template>

                    <template v-if="step == 4">
                        <h1 class="heading1 modal__title">Customizations</h1>

                        <template v-if="tracker.type == 'public'">
                            <p v-if="canEditQuestions">
                                Add fields startups and reviewers fill out in order to apply tracker / evaluate startups.
                            </p>
                        </template>

                        <template v-else>
                            <p >
                                Add fields reviewers fill out in order to better evaluate startups.
                            </p>
                        </template>

                        <template v-if="tracker.type == 'public'">
                            <h5 class="heading5 heading5--secondary">Questions</h5>
                            <p class="tracker-hint">Fields startups will need to fill out when applying to this tracker”</p>

                            <draggable v-model="tracker.questions" class="list-drag-n-drop list-drag-n-drop--full list-drag-n-drop--complex">
                                <div v-for="(question, index) in tracker.questions" :key="'q'+index" class="list-drag-n-drop__item mb-2">
                                    <span></span>
                                    <multiselect class="multiselect-mid"
                                                 v-model="tracker.questions[index]"
                                                 :options="actualQuestionsList"
                                                 :disabled="!canEditQuestions"
                                                 select-label=""
                                                 deselect-label=""
                                                 label="name"
                                                 track-by="name"
                                    >
                                    </multiselect>
                                    <div v-if="canEditQuestions" class="ml-2 text-right">
                                        <a @click="tracker.questions.splice(index, 1)" class="link link-normal">Remove</a>
                                    </div>
                                </div>
                            </draggable>

                            <div class="link-wrapper" v-if="canEditQuestions">
                                <a @click="tracker.questions.push(null)" class="link">+ Add Question</a>
                            </div>
                        </template>

                        <template v-if="tracker.reviewsEnabled == 1">
                            <h5 class="heading5 heading5--secondary">Reviewer Fields</h5>
                            <p class="tracker-hint">Fields your team members will fill out in order to review startups</p>

                            <div v-for="(field, index) in tracker.reviewerFields" :key="'r'+index">
                                <multiselect class="multiselect-mid mb-2"
                                     v-model="tracker.reviewerFields[index].field"
                                     :options="actualReviewerFieldsList"
                                     :disabled="!canEditReviewFields"
                                     select-label=""
                                     deselect-label=""
                                     label="name"
                                     track-by="name"
                                >
                                </multiselect>
                                
                                <div class="d-flex align-items-center justify-content-between mb-4">
                                    <div class="input-checkbox">
                                        <input :id="'mandatory-'+index" type="checkbox" v-model="tracker.reviewerFields[index].required">
                                        <label :for="'mandatory-'+index">Make mandatory</label>
                                    </div>
    
                                    <div v-if="canEditReviewFields" class="text-right">
                                        <a @click="tracker.reviewerFields.splice(index, 1)" class="link-remove"></a>
                                    </div>
                                </div>
                            </div>

                            <div class="link-wrapper" v-if="canEditReviewFields">
                                <a @click="tracker.reviewerFields.push({field: null, required: 0})" class="link">+ Add Field</a>
                            </div>
                        </template>

                        <h5 class="heading5 heading5--secondary">Startup Diligence Fields</h5>
                        <p class="tracker-hint">Fields that can be used as columns in your tracker that can be filled in by users</p>

                        <div v-for="(field, index) in tracker.diligenceFields" :key="index">
                            <multiselect class="multiselect-mid mb-2"
                                         v-model="tracker.diligenceFields[index]"
                                         :options="actualDiligenceFields"
                                         :disabled="!canEditInfo"
                                         select-label=""
                                         deselect-label=""
                                         label="name"
                                         track-by="name"
                            >
                            </multiselect>
                            <div class="text-right mb-2" v-if="canEditInfo">
                                <a @click="tracker.diligenceFields.splice(index, 1)" class="link link-normal">Remove</a>
                            </div>
                        </div>

                        <div class="link-wrapper" v-if="canEditInfo">
                            <a @click="tracker.diligenceFields.push(null)" class="link">+ Add Field</a>
                        </div>
                    </template>

                </template>
                <footer class="modal__bottom" v-if="!selectTemplateStep">
                    <div class="modal__bottom__inner">
                        <b-button v-if="step < 4 && advancedMode" variant="primary" size="lg" :disabled="!canNext" @click="nextStep">Next</b-button>
                        
                        <div v-if="step == 4" class="mb-4">
                            <a  v-if="tracker.type == 'public'" @click="showTermsModal" class="link">+ Add Terms and Conditions</a>
                        </div>
        
                        <b-button v-if="step == 4 || !advancedMode" :disabled="!tracker.name.length" variant="primary" size="lg" @click="save"><template v-if="id > 0">Update</template><template v-else>Create</template> Tracker</b-button>
                    </div>
                </footer>
            </div>

        </div>

        <EditField
            ref="EditPipeline"
            type="tracker_diligence"
            fieldType="pipeline"
            :sectionId="0"
            :index="'tracker-pipeline-'+prefix"
            v-on:fieldSaved="updatePipeline"
        >
        </EditField>

        <EditField
            ref="EditQuestion"
            type="tracker_question"
            :sectionId="0"
            :index="'tracker-question-'+prefix"
            v-on:fieldSaved="updateQuestion"
        >
        </EditField>

        <EditField
            ref="EditReview"
            type="tracker_review"
            :sectionId="0"
            :index="'tracker-review-'+prefix"
            v-on:fieldSaved="updateReview"
        >
        </EditField>

        <b-modal :id="'modal-edit-tracker-terms' + prefix" title="Add Terms and Conditions" @hide="closeTermsModal">

            <editor
                v-if="showTermsEditor"
                v-model="tracker.termsAndConditions"
                :disabled="!canEditInfo"
                :apiKey="apiKeys.tinyMCE"
                :init="defaults.editorOptions"
            >
            </editor>

            <template #modal-footer>
                <b-button variant="primary" size="lg" @click="$bvModal.hide('modal-edit-tracker-terms' + prefix)">Save</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import trackers from "@/services/trackers.service"
import categories from "@/services/categories.service"
import customFields from "@/services/custom-fields.service"
import enterprise from "@/services/enterprise.service"
import multiselect from "vue-multiselect"
import DatePicker from "vue2-datepicker"
import EditField from "@/components/customFields/EditField"
import CustomField from "@/components/customFields/CustomField"
import Avatar from 'vue-avatar'
import editor from "@tinymce/tinymce-vue";
import Vue from "vue";
import draggable from "vuedraggable";

export default {
    props: {
        folderId: Number,
        prefix: {
            type: String,
            default: "",
        }
    },

    components: {
        multiselect,
        DatePicker,
        EditField,
        CustomField,
        Avatar,
        editor,
        draggable,
    },

    data() {
        return {
            showTermsEditor: false,

            id: 0,
            step: 1,

            selectedTemplate: null,

            advancedMode: false,
            selectTemplateStep: false,

            templatesList: {
                default: [],
                custom: [],
            },

            foldersList: [],
            categoriesList: [],
            pipelinesList: [],
            timeline: [null, null],
            questionsList: [],
            reviewerFieldsList: [],
            submitterFieldsList: [],
            diligenceFieldsList: [],
            currentQuestionIndex: -1,
            currentReviewIndex: -1,
            newSubmitField: null,

            permissionHolders: [],
            newPermission: {
                holder: null,
                role: 'manager',
            },

            roles: [],

            tracker: {
                name: '',
                folder: null,
                categories: [],
                description: '',
                pipeline: null,
                startDate: null,
                endDate: null,
                type: null,
                enablePipeline: true,
                defaultView: 'pipeline',
                reviewsEnabled: 1,
                needCompleteProfile: 0,
                onlyReferral: 0,
                InternalAccessById: 0,
                questions: [],
                reviewerFields: [],
                submitterFields: [],
                diligenceFields: [],
                permissions: [],
                userPermissions: [],
                termsAndConditions: "",
            },

            initDiligenceFields: [],
            initReviewerFields: [],
            fieldFilesNumber : 0,

            watchChanges: false,
            trackerChanged: false,
            forceClose: false,
            showModal: false,
        }
    },

    watch: {
        timeline() {
            if (this.timeline[0]) {
                let interval = this.dateHelper.encodeIntervalForServer(this.timeline)
                this.tracker.startDate = interval[0]
                this.tracker.endDate = interval[1]
            }
            else {
                this.tracker.startDate = null
                this.tracker.endDate = null
            }
        },

        tracker: {
            deep: true,
            handler() {
                if (this.watchChanges) {
                    this.trackerChanged = true
                }
            }
        },

        'tracker.folder'() {
            if (this.tracker.folder && this.tracker.folder.id && !this.id) {
                this.tracker.permissions = this.tracker.folder.permissions
            }
        },

        'tracker.pipeline'() {
            if (this.tracker.pipeline && this.tracker.pipeline.id == -1) {
                this.$refs.EditPipeline.open(0)
                this.tracker.pipeline = null
            }
        },

        'tracker.questions'() {
            this.tracker.questions.forEach((item, index) => {

                if (item && item.id == -1) {
                    this.currentQuestionIndex = index
                    this.tracker.questions[index] = null
                    this.$refs.EditQuestion.open(0)
                }
            })
        },

        'tracker.reviewerFields': {
            deep: true,
            handler() {
                this.tracker.reviewerFields.forEach((item, index) => {

                    if (item.field && item.field.id == -1) {
                        this.currentReviewIndex = index
                        this.tracker.reviewerFields[index].field = null
                        this.$refs.EditReview.open(0)
                    }
                })
            }
        },

        selectedTemplate() {
            if (this.selectedTemplate) {
                this.tracker.name = this.selectedTemplate.tracker_name
                this.tracker.description = this.selectedTemplate.description
                this.tracker.defaultView = this.selectedTemplate.default_view
                this.tracker.reviewsEnabled = this.selectedTemplate.reviews_enabled
                this.tracker.pipeline = this.selectedTemplate.pipeline

                if (this.selectedTemplate.start_date || this.selectedTemplate.end_date) {
                    this.timeline = this.dateHelper.decodeIntervalFromServer([this.selectedTemplate.start_date, this.selectedTemplate.end_date])
                }

                this.tracker.categories = this.selectedTemplate.categories

                this.tracker.reviewerFields = []
                this.selectedTemplate.reviewer_fields.forEach(item => {
                    this.tracker.reviewerFields.push({
                        field: item,
                        required: 0
                    })
                })

                this.tracker.diligenceFields = this.selectedTemplate.diligence_fields

                this.tracker.submitterFields = []
                this.selectedTemplate.submitter_fields.forEach(item => {
                    let field = this.submitterFieldsList[item.id]

                    this.tracker.submitterFields.push({
                        field: field,
                        value: {
                            value: "",
                            options: [],
                            files: [],
                            links: []
                        },
                    })
                })
            }
        }
    },

    computed: {
        hasReviewStep() {
            return this.tracker.type == 'public' || this.tracker.reviewsEnabled
        },
        //title() {
        //    if (this.step == 1 && !this.tracker.name.length) {
        //        return "Create New Tracker"
        //    }
        //    else {
        //        return "Choose a Template"
        //    }
        //},

        canNext() {
            if (this.step == 2 && !this.tracker.name.length) {
                return false
            }
            else if (this.step == 3 && this.tracker.defaultView == 'pipeline' && !this.tracker.pipeline) {
                return false
            }
            else {
                return true
            }
        },

        actualPermissionHolders() {
            let array = []
            this.permissionHolders.forEach(item => {
                if (!this.arrayHelper.exists(this.tracker.permissions, ['type', 'id'], [item.type, item.id])) {
                    array.push(item)
                }
            })

            return array
        },

        canEditInfo() {
            if (this.id) {
                return this.tracker.userPermissions.indexOf('tracker-edit') >= 0
            }
            else {
                return true
            }
        },

        canManageRoles() {
            if (this.id) {
                return this.tracker.userPermissions.indexOf('tracker-permissions-edit') >= 0
            }
            else {
                return true
            }
        },

        canManageSubmitterFields() {
            if (this.id) {
                return this.tracker.userPermissions.indexOf('tracker-submitterFields-edit') >= 0
            }
            else {
                return true
            }
        },

        canFillSubmitterFields() {
            if (this.id) {
                return this.tracker.userPermissions.indexOf('tracker-submitterFields-value-edit') >= 0
            }
            else {
                return true
            }
        },

        canEditQuestions() {
            if (this.id) {
                return this.tracker.userPermissions.indexOf('tracker-questions-edit') >= 0
            }
            else {
                return true
            }
        },

        canEditReviewFields() {
            if (this.id) {
                return this.tracker.userPermissions.indexOf('tracker-reviewerFields-edit') >= 0
            }
            else {
                return true
            }
        },

        actualSubmitterFields() {
            let newArray = {}

            for (let i in this.submitterFieldsList) {
                let exists = false

                this.tracker.submitterFields.forEach(item => {
                    if (item.field.id == i) {
                        exists = true
                        return
                    }
                })

                if (!exists) {
                    newArray[i] = this.submitterFieldsList[i]
                }
            }

            return newArray
        },

        actualDiligenceFields() {
            return this.arrayHelper.arrayDiff(this.diligenceFieldsList, this.tracker.diligenceFields, 'id')
        },

        actualReviewerFieldsList() {
            let existed = []
            this.tracker.reviewerFields.forEach(item => {
                if (item.field != null) {
                    existed.push(item.field.id)
                }
            })

            let array = []
            this.reviewerFieldsList.forEach(item => {
                if (existed.indexOf(item.id) < 0) {
                    array.push(item)
                }
            })
            return array
        },

        actualQuestionsList() {
            return this.arrayHelper.arrayDiff(this.questionsList, this.tracker.questions, 'id')
        }
    },

    mounted() {
        trackers.getRoles().then(result => {
            this.roles = result.data

            this.newPermission.role = this.roles[0]
        })

        categories.getList().then(response => {
            this.categoriesList = response.data
        })
    },

    methods: {
        setTrackerType(type) {
            this.tracker.type = type
            this.step = 2

            this.$nextTick(() => {
                this.watchChanges = true
            })
        },

        nextStep() {
            if (this.step == 2 && !this.tracker.enablePipeline) {
                this.step = 4
            }
            else {
                ++this.step
            }
        },

        prevStep() {
            if (this.selectTemplateStep) {
                this.selectTemplateStep = false
                this.step = 2
            }
            else if (this.step == 4 && !this.tracker.enablePipeline) {
                this.step = 2
            } else {
                --this.step
            }
        },

        getFieldsList() {
            trackers.getPipelinesList().then(response => {
                this.pipelinesList = response.data

                this.pipelinesList.push({
                    id: -1,
                    name: "Create New Funnel",
                    steps: [],
                })

                if (!this.id && this.pipelinesList.length) {
                    this.tracker.pipeline = this.pipelinesList[0]
                }
            })

            customFields.getList('tracker_question').then(response => {
                this.questionsList = response.data
                this.questionsList.push({
                    id: -1,
                    name: "Create New Question",
                })
            })

            customFields.getList('tracker_review').then(response => {
                this.reviewerFieldsList = response.data

                this.reviewerFieldsList.push({
                    id: -1,
                    name: "Create New Field",
                })
            })

            customFields.getFields('tracker_submit').then(response => {
                this.submitterFieldsList = response.data
            })

            customFields.getList('tracker_diligence').then(response => {
                this.diligenceFieldsList = response.data
            })

            trackers.getTemplates().then(response => {
                this.templatesList = response.data
            })
        },

        getFoldersList() {
            trackers.getFoldersList().then(response => {
                this.foldersList = response.data
                this.foldersList.unshift({id: 0, name: 'None'})

                if (this.folderId) {
                    let index = this.arrayHelper.findIndexByColumnValue(this.foldersList, 'id', this.folderId)

                    if (index) {
                        this.tracker.folder = this.foldersList[index]
                    }
                }
            })
        },

        getPermissionHolders() {
            enterprise.getPermissionHolders().then(response => {
                this.permissionHolders = response.data
            })
        },

        beforeClose(event) {
            if (!this.forceClose && this.trackerChanged && !confirm("Your changes are not saved and will be lost. Please confirm to proceed.")) {
                event.preventDefault()
            }
        },

        init() {
            this.getFieldsList()
            this.getFoldersList()
            this.getPermissionHolders()

            this.showTermsEditor = false
            this.tracker.name = ""
            this.tracker.type = "internal"
            this.tracker.description = ""
            this.tracker.enablePipeline = true
            this.tracker.defaultView = "pipeline"
            this.tracker.reviewsEnabled = 1
            this.tracker.needCompleteProfile = 1
            this.tracker.onlyReferral = 0
            this.tracker.pipeline = null
            this.tracker.categories = []
            this.tracker.startDate = null
            this.tracker.endDate = null
            this.tracker.questions = []
            this.tracker.submitterFields = []
            this.tracker.diligenceFields = []
            this.tracker.permissions = []
            this.tracker.userPermissions = []
            this.tracker.termsAndConditions = ""
            this.timeline = [null, null]
            this.advancedMode = false
            this.selectTemplateStep = false
            this.selectedTemplate = null

            this.forceClose = false
            this.trackerChanged = false
            this.watchChanges = false

            if (this.id) {
                this.step = 2

                trackers.getTrackerEdit(this.id).then(response => {
                    this.advancedMode = true
                    this.tracker.name = response.data.name
                    this.tracker.type = response.data.type
                    this.tracker.description = response.data.description
                    this.tracker.enablePipeline = response.data.enable_pipeline
                    this.tracker.defaultView = response.data.default_view
                    this.tracker.reviewsEnabled = response.data.reviews_enabled
                    this.tracker.needCompleteProfile = response.data.need_complete_profile
                    this.tracker.onlyReferral = response.data.only_referral
                    this.tracker.InternalAccessById = response.data.internal_access_by_id
                    this.tracker.folder = response.data.folder
                    this.tracker.startDate = response.data.start_date
                    this.tracker.endDate = response.data.end_date
                    this.tracker.questions = response.data.questions
                    this.tracker.reviewerFields = response.data.reviewer_fields
                    this.tracker.submitterFields = response.data.submitter_fields
                    this.tracker.diligenceFields = response.data.diligence_fields
                    this.tracker.permissions = response.data.permissions
                    this.tracker.userPermissions = response.data.user_permissions
                    this.tracker.termsAndConditions = response.data.terms_and_conditions

                    this.initDiligenceFields = this.arrayHelper.cloneArray(this.tracker.diligenceFields)
                    this.initReviewerFields = this.arrayHelper.cloneArray(this.tracker.reviewerFields)

                    if (response.data.start_date != null) {
                        this.timeline = this.dateHelper.decodeIntervalFromServer([response.data.start_date, response.data.end_date])
                    }

                    this.tracker.pipeline = response.data.pipeline
                    this.tracker.categories = response.data.categories

                    this.$nextTick(() => {
                        this.watchChanges = true
                    })
                })
            }
            else {
                if (this.$store.state.user.enterprise_type == 'free') {
                    this.step = 2
                }
                else {
                    this.step = 1
                }

                if (this.folderId) {
                    trackers.getFolderInfo(this.folderId).then(response => {
                        this.tracker.permissions = response.data.permissions
                    })
                }
                else {
                    this.tracker.folder = null
                }

                if (this.pipelinesList.length) {
                    this.tracker.pipeline = this.pipelinesList[0]
                }

                this.tracker.permissions.push(
                    {
                        type: 'user',
                        id: this.$store.state.user.id,
                        name: this.$store.state.user.name,
                        role: this.newPermission.role,
                        avatar: this.$store.state.user.avatar,
                    }
                )
            }
        },

        open(id) {
            this.id = id
            this.init()
            this.showModal = true
            document.body.classList.add('modal-open')
        },

        close() {
            this.showModal = false
            document.body.classList.remove('modal-open')
        },

        save() {
            let removed = false
            this.initDiligenceFields.forEach(item => {
                if (!this.arrayHelper.exists(this.tracker.diligenceFields, 'id', item.id)) {
                    removed = true
                    return
                }
            })


            if (!removed || confirm("Fields you removed from tracker will cause their values removing for existing startups. Do you want to proceed?")) {

                trackers.save(this.id, this.tracker).then((response) => {
                    this.fieldFilesNumber = this.fileHelper.fieldsWithNewFilesNumber(this.tracker.submitterFields)
                    let trackerId = response.data

                    if (this.fieldFilesNumber) {
                        this.tracker.submitterFields.forEach(field => {

                            let formData = new FormData();
                            let hasFiles = false

                            field.value.files.forEach(file => {
                                if (file.id == 0) {
                                    formData.append('file[]', file)
                                    hasFiles = true
                                }
                            })

                            if (hasFiles) {
                                trackers.saveSubmitterFiles(trackerId, field.field.id, formData).then(() => {
                                    this.fieldFilesSaved()
                                })
                            }
                        })
                    }
                    else {
                        this.$emit('trackerSaved', trackerId)
                        this.forceClose = true
                        this.close()

                        Vue.notify({
                            group: 'app',
                            type: 'success',
                            text: this.id ? "Tracker updated" : "Tracker created"
                        })
                    }
                })
            }
        },

        fieldFilesSaved() {
            --this.fieldFilesNumber

            if (!this.fieldFilesNumber) {
                this.$emit('trackerSaved')
                this.forceClose = true
                this.close()

                Vue.notify({
                    group: 'app',
                    type: 'success',
                    text: this.id ? "Tracker updated" : "Tracker created"
                })
            }
        },

        addSubmitterField() {
            this.tracker.submitterFields.push({
                field: this.newSubmitField,
                value: {
                    value: "",
                    options: [],
                    files: [],
                    links: []
                },
            })

            this.newSubmitField = null
            this.$bvModal.hide('addSubmitterFieldModal' + this.prefix)
        },

        updatePipeline(id) {
            trackers.getPipelinesList().then(response => {
                this.pipelinesList = response.data
                this.pipelinesList.push({
                    id: -1,
                    name: "Create New Funnel",
                    steps: [],
                })

                let index = this.arrayHelper.findIndexByColumnValue(this.pipelinesList, 'id', id)
                this.tracker.pipeline = this.pipelinesList[index]
            })
        },

        updateQuestion(id) {
            customFields.getList('tracker_question').then(response => {
                this.questionsList = response.data
                this.questionsList.push({
                    id: -1,
                    name: "Create New Question",
                })

                let index = this.arrayHelper.findIndexByColumnValue(this.questionsList, 'id', id)
                this.tracker.questions[this.currentQuestionIndex] = this.questionsList[index]
            })
        },

        updateReview(id) {
            customFields.getList('tracker_review').then(response => {
                this.reviewerFieldsList = response.data
                this.reviewerFieldsList.push({
                    id: -1,
                    name: "Create New Field",
                })

                let index = this.arrayHelper.findIndexByColumnValue(this.reviewerFieldsList, 'id', id)
                this.tracker.reviewerFields[this.currentReviewIndex].field = this.reviewerFieldsList[index]
            })
        },

        submitterValueChanged({index, value}) {
            this.tracker.submitterFields[index].value = value

            if (this.tracker.submitterFields[index].field.type == 'date') {
                this.tracker.submitterFields[index].value.value = this.dateHelper.decodeDate(this.tracker.submitterFields[index].value.value)
            }
        },

        addPermission() {
            this.tracker.permissions.push(
                {
                    type: this.newPermission.holder.type,
                    id: this.newPermission.holder.id,
                    name: this.newPermission.holder.name,
                    role: this.newPermission.role,
                    avatar: this.newPermission.holder.avatar,
                }
            )

            this.newPermission.holder = null
        },

        showTermsModal() {
            this.$bvModal.show('modal-edit-tracker-terms' + this.prefix)
            this.$nextTick(() => {
                this.showTermsEditor = true
            })
        },

        closeTermsModal() {
            this.showTermsEditor = false
        }
    }
}
</script>

<style scoped>

</style>